export default {"src":"/gallery/_next/static/media/logo_small.f8e14304.svg","height":55,"width":55,"blurWidth":0,"blurHeight":0};